import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import mixpanelService from "./mixpanelService";
import mixpanelEvents, { getScreenName } from "../../config/mixpanelEvents";

const MixpanelPageTracker = () => {
  const location = useLocation();
  const lastPathnameRef = useRef<string>("");

  useEffect(() => {
    try {
      if (location.pathname === lastPathnameRef.current) return;
      lastPathnameRef.current = location.pathname;

      const screen_name = getScreenName(location.pathname);
      if (!screen_name) return;

      mixpanelService({ event: mixpanelEvents.SCREEN_LOAD, screen_name });
    } catch (e) {
      console.error("mixpanel screen_load failed", e);
    }
  }, [location.pathname]);

  return null;
};

export default MixpanelPageTracker;
